import { gql } from '@apollo/client'
import {
    ProductFamilyTableViewFragment,
    overviewMetadataFragment,
} from 'api/graphQL/fragments/StudioManagement/studioManagement.fragments'

export const AllUniqueProductFamilyDataForStudioManagementQuery = gql`
    query allUniqueProductFamilyDataForStudioManagement(
        $input: GetResultsInput
    ) {
        allUniqueProductFamilyDataForStudioManagement(input: $input) {
            count
            productFamilyTableView {
                ...productFamilyTableViewFragment
            }
        }
    }
    ${ProductFamilyTableViewFragment}
`

export const GetWorkItemsForOfficeMasterDashboardQuery = gql`
    query getWorkItemsForOfficeMasterDashboard($input: GetResultsInput!) {
        getWorkItemsForOfficeMasterDashboard(input: $input) {
            count
            workItemBuckets {
                text
                productFamilyTableView {
                    ...productFamilyTableViewFragment
                }
            }
        }
    }
    ${ProductFamilyTableViewFragment}
`

export const GetManufacturerDetails = gql`
    query firm($id: String!) {
        firm(id: $id) {
            name
            displayName
            status
            firmId
            profileInfo {
                publicPhone
                website
                whoWeAre
                address {
                    street1
                    street2
                    city
                    region
                    country
                    postalCode
                }
            }
        }
    }
`

export const FirmAutoSuggestQuery = gql`
    query FirmAutoSuggestQuery($input: FirmAutoSuggestInput!) {
        firmAutoSuggest(input: $input) {
            result
        }
    }
`

export const FirmIdByDisplayNameQuery = gql`
    query firmNameQuery($firmName: String!) {
        getFirmByDisplayName(displayName: $firmName) {
            firmId
            displayName
        }
    }
`

export const AddExistingManufacturer = gql`
    mutation createProductListingDetailMutaion($input: ListingDetailInput) {
        createProductListingDetail(input: $input) {
            listingId
            productType
            sectionNumber
            sectionTitle
            type
            isActive
            isDeltekWriterDraft
        }
    }
`

export const GetNotAddedPTMetadata = gql`
    query nugget($id: String!, $firmId: String!) {
        nugget(id: $id, firmId: $firmId) {
            id
            metadata {
                ...overviewMetadataFragment
            }
        }
    }
    ${overviewMetadataFragment}
`
export const GetNotAddedFamilyMetadata = gql`
    query productFamily($id: String!, $firmId: String!) {
        productFamily(id: $id, firmId: $firmId) {
            id
            publishedDate
            status
            attachedToFirmId
            familyManagementDetails {
                familyTypeEnum
                masterFormatEdition
                discipline
                versionNumber
                familyOwner
                divisionName
                nextTargetUpdateDate
                targetReviewDate
                actualReviewDate
            }
            productFamilyCategories {
                id
                name
            }
            metadata {
                ...overviewMetadataFragment
            }
        }
    }
    ${overviewMetadataFragment}
`

export const GetAddedPTMetadata = gql`
    query getProjectNugget($input: GetProjectElementInput!) {
        getProjectNugget(input: $input) {
            id
            metadata {
                ...overviewMetadataFragment
            }
        }
    }
    ${overviewMetadataFragment}
`

export const GetAddedFamilyMetadata = gql`
    query getProjectProductFamily($input: GetProjectElementInput!) {
        getProjectProductFamily(input: $input) {
            id
            publishedDate
            status
            familyManagementDetails {
                familyTypeEnum
                masterFormatEdition
                discipline
                versionNumber
                familyOwner
                divisionName
                nextTargetUpdateDate
                targetReviewDate
                actualReviewDate
            }
            productFamilyCategories {
                id
                name
            }
            projectElementMetadata {
                baseElementId
            }
            metadata {
                ...overviewMetadataFragment
            }
        }
    }
    ${overviewMetadataFragment}
`

export const SetPrimaryFamilyIterationMutation = gql`
    mutation setPrimaryFamilyIteration($baseElementId: String) {
        setPrimaryFamilyIteration(input: $baseElementId) {
            id
            treePath
            baseElementId
            iterationId
            isPrimaryIteration
        }
    }
`
